/**
 * Format bytes to human-readable file size
 * @param bytes - The number of bytes to format
 * @returns Formatted string like "1.50 KB", "2.30 MB", etc.
 *
 * Note: Uses standard SI units (B, KB, MB, GB, TB) which are internationally recognized
 * and don't require translation.
 */
export function formatBytes(bytes: number | null): string {
  if (!bytes || bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
}

/**
 * Format file size with folder handling
 * @param bytes - The number of bytes to format
 * @param isFolder - Whether this is a folder (displays "—" instead of size)
 * @returns Formatted string or "—" for folders
 */
export function formatFileSize(bytes: number | null, isFolder: boolean): string {
  if (isFolder) return '—';
  return formatBytes(bytes);
}
